var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footerBox",attrs:{"id":"footerBox"}},[_vm._v("© Copyright 2015 - "+_vm._s(_vm.moment().format("YYYY"))+" 长沙鸿星智能科技有限公司 版权所有 | 湘ICP备2020023992号-2号 | 湘公网安备 43019002001389号")])
}
var staticRenderFns = []

export { render, staticRenderFns }